/**
 * Envelope returned by paginated list endpoints.
 *
 * Mirrors the shared backend `PaginatedResponse` — the array is named `results`
 * (not `items`) because that is the cross-service contract every Barti frontend
 * consumes. `page` is 0-indexed.
 */
export interface PaginatedResponse<T> {
  results: T[]
  total_count: number
  page: number
  limit: number
}

/** Page sizes offered in a paginated list's page-size control. */
export const PAGE_SIZE_OPTIONS: number[] = [15, 25, 50, 100]

/** Matches the backend's own default, so an unparameterised request agrees with the UI. */
export const DEFAULT_PAGE_SIZE = 15

/** Mirrors the backend's upper bound on `page`, which rejects anything beyond it. */
export const MAX_PAGE = 10_000
